import { useState } from 'react';
import FormErrors from '../../components/FormErrors';
import { reauthenticate, Flows } from '../../lib/allauth';
import ReauthenticateFlow from './ReauthenticateFlow';
import BaseButton from '../../components/BaseButton';
import BaseTextField from '../../components/BaseTextField';

export default function Reauthenticate() {
  const [password, setPassword] = useState('');
  const [response, setResponse] = useState({ fetching: false, content: null });

  function submit() {
    setResponse({ ...response, fetching: true });
    reauthenticate({ password })
      .then((content) => setResponse((r) => ({ ...r, content })))
      .catch((e) => {
        console.error(e);
        window.alert(e);
      })
      .finally(() => setResponse((r) => ({ ...r, fetching: false })));
  }

  return (
    <ReauthenticateFlow flow={Flows.REAUTHENTICATE}>
      <FormErrors errors={response.content?.errors} />
      <BaseTextField
        label="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        type="password"
        required
      />
      <FormErrors param="password" errors={response.content?.errors} />
      <BaseButton disabled={response.fetching} onClick={submit}>
        Confirm
      </BaseButton>
    </ReauthenticateFlow>
  );
}
